import styled from 'styled-components';

export const Title = styled.h3`
  ${({ theme }) => theme.fontSize.M16};
  margin-bottom: ${({ theme }) => theme.spacing.S4};
  color: ${({ theme }) => theme.colors.GREY_DARKER};
`;
